(function () {
  const STORAGE_KEY = 'sd-scroll-to';
  const TARGET_ID = 'sd-brand-engagement';
  const START_DELAY = 550;
  const DURATION = 1200;

  function easeInOutCubic(progress) {
    return progress < 0.5
      ? 4 * progress * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 3) / 2;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getTargetTop(element) {
    const margin = parseFloat(window.getComputedStyle(element).scrollMarginTop) || 0;
    return Math.max(0, element.getBoundingClientRect().top + window.pageYOffset - margin);
  }

  function consumeTargetId() {
    try {
      const targetId = sessionStorage.getItem(STORAGE_KEY);
      if (targetId) sessionStorage.removeItem(STORAGE_KEY);
      return targetId;
    } catch (error) {
      return null;
    }
  }

  const targetId = consumeTargetId();
  if (targetId !== TARGET_ID) return;

  const element = document.getElementById(TARGET_ID);
  if (!element) return;

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  let cancelled = false;
  let rafId = 0;

  function cancel() {
    cancelled = true;
    if (rafId) window.cancelAnimationFrame(rafId);
  }

  window.addEventListener('wheel', cancel, { passive: true, once: true });
  window.addEventListener('touchstart', cancel, { passive: true, once: true });
  window.addEventListener('keydown', cancel, { once: true });

  function animateScrollTo() {
    if (cancelled) return;

    if (prefersReducedMotion()) {
      window.scrollTo(0, getTargetTop(element));
      return;
    }

    const from = window.pageYOffset;
    const start = performance.now();

    function tick(now) {
      if (cancelled) return;

      const progress = Math.min((now - start) / DURATION, 1);
      const to = getTargetTop(element);
      window.scrollTo(0, from + (to - from) * easeInOutCubic(progress));

      if (progress < 1) {
        rafId = window.requestAnimationFrame(tick);
      }
    }

    rafId = window.requestAnimationFrame(tick);
  }

  window.setTimeout(animateScrollTo, START_DELAY);
})();
